import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';
import { getConferenceTimezone, getConferenceTimezoneLabel, CURRENT_EVENT_YEAR } from '../schedule.js';

dayjs.extend(utc);
dayjs.extend(timezone);

// Same shape as the agenda's detail-card line: "Thu • Sep 17 • 1:30pm - 2:00pm ET".
// The separator pads with a non-breaking space so the two visible spaces survive
// HTML whitespace collapsing while the line can still wrap.
// Explicit escapes: nbsp, space, bullet, nbsp, space (bytes: 0xa0, 0x20, 0x2022, 0xa0, 0x20).
const SEP = '\xa0 •\xa0 ';

export const formatBraindateWhen = (startIso, endIso, year = CURRENT_EVENT_YEAR) => {
    if (!startIso) return '';
    const tz = getConferenceTimezone(year);
    const start = dayjs(startIso).tz(tz);
    const end = endIso ? dayjs(endIso).tz(tz) : null;
    const label = getConferenceTimezoneLabel(year);
    const range = end
        ? `${start.format('h:mma')} - ${end.format('h:mma')} ${label}`
        : `${start.format('h:mma')} ${label}`;
    return `${start.format('ddd')}${SEP}${start.format('MMM D')}${SEP}${range}`;
};
